import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Route } from "react-router-dom";
import { Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import "./App.css";
import SearchJourneyPage from "./pages/SearchJourneyPage";
import AnalyseJourneyPage from "./pages/AnalyseJourneyPage";
import SearchJourneyResultPage from "./pages/SearchJourneyResultPage";
//import JourneyDetailsPage from "./pages/JourneyDetailsPage";
import MapPage from "./pages/MapPage";
import AboutPage from "./pages/AboutPage";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={SearchJourneyPage} exact />
        <Route
          path="/journey/search/:from/:to/:datetime"
          component={SearchJourneyResultPage}
          exact
        />
        <Route
          path="/journey/analyse/:from/:to"
          component={AnalyseJourneyPage}
          exact
        />
        {
          // -- HISTORY DISABLED
          /*<Route
          path="/journey/:journeyId/:from/:to/:datetime"
          component={JourneyDetailsPage}
          exact
        />*/
        }
        <Route path="/map" component={MapPage} exact />
        <Route path="/about" component={AboutPage} exact />
        <Route path="/" component={() => <Redirect to="/" />} />
      </Switch>
    </Router>
  );
}
export default App;
